import get from 'lodash/get'
import { createSelector } from 'reselect'
import { getState } from '@/store/reducers'

export const getDictionaries = createSelector(
    getState,
    (state) => get(state, 'dictionaries', {}),
)

export const getAlertFieldsOptions = createSelector(
    getDictionaries,
    (dictionaries) => get(dictionaries, 'alerFildOptions', []),
)

export const getAlertFieldsOptionsData = createSelector(
    getAlertFieldsOptions,
    (dictionaries) => get(dictionaries, 'data', []),
)

export const getAlertFieldsOptionsLoading = createSelector(
    getAlertFieldsOptions,
    (dictionaries) => get(dictionaries, 'isLoading', []),
)